import React, { useState, useEffect } from "react";
import Table from 'react-bootstrap/Table';
import './styles.css';
import logo from "../images/logo.png";
// import Catch from "./functional-error-boundary";


const Covid = () => {

    const [data, setData] = useState([]);
    // const [search, setSearch] = useState('');
    // const [filterDataResult, setFilterDataResult] = useState([]);


    // const searchTrain = (searchValue) => {
    //     setSearch(searchValue)
    //     // console.log(searchValue);
    //     if (search !== '') {
    //         const filterData = data.filter((item) => {
    //             return item.properties.search != -1;
    //             // Object.values(item).join('').toLowerCase().includes(search.toLowerCase())
    //         })
    //         console.log(filterData);
    //         setFilterDataResult(filterData);
    //     }
    //     else {
    //         setFilterDataResult(data)
    //     }
    // }

    const covidData = async () => {
        const res = await fetch(' https://raw.githubusercontent.com/datameet/railways/master/trains.json');
        const actualData = await res.json();
        // console.log(actualData);
        setData(actualData.features);
    }

    useEffect(() => {
        covidData();
    }, []);



    return (
        <>

            <a href="http://www.indianrail.gov.in/enquiry/StaticPages/StaticEnquiry.jsp?StaticPage=index.html" target="_blank"><img src={logo} alt="Logo"/></a>
            <h1>Indian Railway</h1>

            <div className="search">
                <input
                    placeholder="Train Number"
                //  onChange={(e) => searchTrain(e.target.value)}
                // onKeyPress={(e) => {
                //     if (!/[0-9]/.test(e.key)) {
                //         e.preventDefault();
                //     }
                // }}
                />


            </div>
            <div>
                <Table striped responsive>
                    <thead>
                        <tr>
                            <th>Train Name</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Train Number</th>
                            <th>Arrival</th>
                            <th>Departure</th>
                            <th>Train Type</th>
                            <th>Distance</th>

                        </tr>
                    </thead>
                    <tbody>


                        {
                            /* search.length > 1 ? (
                                 filterDataResult.map((e, i) => {
                                     return
                                     (
                                         <tr key={i} >
                                             <td>{e.properties.name}</td>
                                             <td>{e.properties.from_station_name}</td>
                                             <td>{e.properties.to_station_name}</td>
                                             <td>{e.properties.number}</td>
                                             <td>{e.properties.arrival}</td>
                                             <td>{e.properties.departure}</td>
                                             <td>{e.properties.type}</td>
                                             <td>{e.properties.distance}</td>
 
 
                                         </tr>
                                     )
                                 })
                             ) :*/
                            (

                                data.map((e, i) => {
                                    return (
                                        <tr key={i} >
                                            <td>{e.properties.name}</td>
                                            <td>{e.properties.from_station_name}</td>
                                            <td>{e.properties.to_station_name}</td>
                                            <td>{e.properties.number}</td>
                                            <td>{e.properties.arrival}</td>
                                            <td>{e.properties.departure}</td>
                                            <td>{e.properties.type}</td>
                                            <td>{e.properties.distance}</td>

                                        </tr>
                                    );

                                })
                            )
                        }

                    </tbody>
                </Table>
            </div>
        </>
    );
}

export default Covid;